import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private user: any;
  private _accessToken: string | null = null;

  constructor(
    private router: Router,
    private api: ApiService
  ) { }

  getUser(): any {
    const userString = sessionStorage.getItem('user');
    return this.user ? this.user : userString ? JSON.parse(userString) : null;
  }


  get userObj(): any {
    const userString = sessionStorage.getItem('user');
    this.user = userString ? JSON.parse(userString) : null;
    return this.user;
  }


  setUser(data: any) {
    this._accessToken = data?.token || null;
    this.user = { ...data };
    delete this.user.token;
    delete this.user.refreshToken;
    delete this.user.sessionToken;
    sessionStorage.setItem('user', JSON.stringify(this.user));
    if (data?.token) sessionStorage.setItem('auth_token', data.token);
    if (data?.sessionToken) sessionStorage.setItem('auth_sessionToken', data.sessionToken);
  }

  getToken(): string | null {
    return this._accessToken || null;
  }

  logout() {
    const vm = this;
    
    // Call logout API to blacklist the token (cookie sent automatically)
    this.api.postData('/partners/noAuth/logout', {}).subscribe({
      next: () => {
        vm.clearSessionAndNavigate();
      },
      error: () => {
        vm.clearSessionAndNavigate();
      }
    });
  }

  private clearSessionAndNavigate() {
    this._accessToken = null;
    this.user = null;
    // Clear all session data
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('sessionToken');
    sessionStorage.removeItem('auth_sessionToken');
    
    // Navigate to login
    this.router.navigate(['/']);
  }
}
